import { render, staticRenderFns } from "./TooltipAbnahmeBlitzschutz.vue?vue&type=template&id=11fac6bf&scoped=true&"
import script from "./TooltipAbnahmeBlitzschutz.vue?vue&type=script&lang=js&"
export * from "./TooltipAbnahmeBlitzschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fac6bf",
  null
  
)

export default component.exports